<template>
  <div
    v-if="supportsSurvey"
    class="flex justify-center"
    :class="{ 'w-full': showingForm }"
  >
    <div v-if="memberCompletedSurveyThisPeriod(memberId)" class="space-y-8">
      <Body>
        <span class="font-bold">
          {{ $t('health_actions.survey.completed') }}
        </span>
        {{ mostRecentSurveyCompletion(memberId) | FD }}
      </Body>
    </div>
    <div v-else-if="!showingForm" class="text-center">
      <HMButton rounded="full" @click="showingForm = true">
        {{ $t('health_actions.survey.start_survey') }}
      </HMButton>
    </div>
    <div v-else class="w-full">
      <SurveySubmitted v-if="successfulSubmission" />
      <SurveyFormWrapper
        :surveyConfig="surveyConfig"
        :surveyId="surveyId"
        :healthActionId="healthActionId"
        @complete="successfulSubmission = true"
      />
    </div>
  </div>
</template>

<script>
import healthActionMixin from '@platform-shared/mixins/health-actions/healthActionMixin.js'
import SurveySubmitted from './SurveySubmitted.vue'
import SurveyFormWrapper from './SurveyFormWrapper.vue'

export default {
  // TODO: Support completing surveys for dependents (can reference ../MemberAttestation/Attestation.vue)
  components: {
    SurveySubmitted,
    SurveyFormWrapper,
  },
  mixins: [healthActionMixin],
  props: {
    memberId: {
      type: Number,
      required: false,
      default: undefined,
    },
  },
  data() {
    return {
      showingForm: false,
      successfulSubmission: false,
    }
  },
}
</script>
